import React from 'react';
import { Star } from 'lucide-react';

// Review data with images from webimages/ folder
const reviews = [
  {
    name: 'James T.',
    location: 'New York, USA',
    image: '/webimages/Screenshot 2025-12-04 at 15.31.04.png',
    statement: 'HDAlgos caught this breakout before it happened',
  },
  {
    name: 'Michael R.',
    location: 'London, UK',
    image: '/webimages/Screenshot 2025-12-04 at 15.31.15.png',
    statement: 'Perfect entry signal from the trend exhaustion system',
  },
  {
    name: 'David K.',
    location: 'Singapore',
    image: '/webimages/Screenshot 2025-12-04 at 15.31.21.png',
    statement: 'The forecast engine nailed this momentum shift',
  },
  {
    name: 'Chris M.',
    location: 'Toronto, Canada',
    image: '/webimages/Screenshot 2025-12-04 at 15.31.32.png',
    statement: 'Volatility breakout alert helped me size this perfectly',
  },
  {
    name: 'Alex P.',
    location: 'Sydney, Australia',
    image: '/webimages/Screenshot 2025-12-04 at 15.31.53.png',
    statement: 'HDAlgos regime detection saved me from this chop',
  },
  {
    name: 'Ryan S.',
    location: 'Dubai, UAE',
    image: '/webimages/Screenshot 2025-12-04 at 15.31.57.png',
    statement: 'Combined forecast gave me the conviction to hold',
  },
  {
    name: 'Kevin L.',
    location: 'Hong Kong',
    image: '/webimages/Screenshot 2025-12-04 at 15.32.02.png',
    statement: 'Best entry timing since using these systems',
  },
];

function ReviewCard({ review }) {
  return (
    <div className="flex-shrink-0 w-80 md:w-96 mx-4">
      <div className="bg-[#1a1a1a] overflow-hidden border border-white/10 hover:border-[#CBB26A]/30 transition-all duration-300">
        {/* Image */}
        <div className="aspect-video overflow-hidden">
          <img
            src={review.image}
            alt={review.name + " trade"}
            className="w-full h-full object-cover"
          />
        </div>
        
        {/* Info */}
        <div className="p-5">
          {/* 5 Star Rating */}
          <div className="flex gap-1 mb-3">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-4 h-4 fill-[#CBB26A] text-[#CBB26A]" />
            ))}
          </div>
          
          {/* HDAlgos Bot Statement */}
          <div className="flex items-center justify-between">
            <div>
              <p className="text-[#CBB26A] font-semibold text-sm">{review.statement}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function ReviewsSection() {
  // Double the reviews for seamless infinite scroll
  const doubled = [...reviews, ...reviews];

  return (
    <div className="w-full overflow-hidden pb-16">
      {/* Carousel - Same style as logo carousel */}
      <div className="relative">
        {/* Gradient masks */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#0d1117] to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#0d1117] to-transparent z-10 pointer-events-none" />
        
        {/* Scrolling container */}
        <div className="flex animate-scroll-left-slow items-center">
          {doubled.map((review, index) => (
            <ReviewCard key={"review-" + index} review={review} />
          ))}
        </div>
      </div>

      {/* Trust indicator */}
      <div className="flex items-center justify-center gap-2 mt-8 px-6">
        <div className="flex -space-x-2">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="w-8 h-8 rounded-full bg-gradient-to-br from-[#CBB26A] to-[#A8914D] border-2 border-[#0d1117] flex items-center justify-center text-xs font-bold text-black">
              {String.fromCharCode(65 + i)}
            </div>
          ))}
        </div>
        <span className="text-gray-400 text-sm ml-2">1000+ active traders trust HDAlgos</span>
      </div>
    </div>
  );
}
